import { Stack, Grid, Typography, Chip, Box, Fab } from "@mui/material";
import { useState } from "react";
import { keys } from "../../config/nameSpacesKeys";
import { isEmpty } from "../../config/commonFunctions";
import { useTranslator } from "../../context/TranslatorContext";
import {ReactComponent as OpenLockIcon} from "../../assets/icons/Lock-Open--Streamline-Sharp-Material-Symbols.svg";

export default function AssetOfferHeader(props) {
  const [mappings, setMappings] = useState(props.mappings);
  const { messages } = useTranslator();
  const defaultLanguage = props.defaultLanguage;
  // console.log(defaultLanguage);
  let initialLrType;
  if (props?.lrType?.includes("corpus")) {
    initialLrType = "corpus";
  } else if (props?.lrType?.includes("lexicalConceptualResource")) {
    initialLrType = "lexicalConceptualResource";
  } else if (props?.lrType?.includes("mlModel") || props?.lrType?.includes("mLModel") || props?.lrType?.includes("machineLearningModel")) {
    initialLrType = "model";
  } else if (props?.lrType?.includes("toolService")) {
    initialLrType = "toolService";
  } else {
    initialLrType = null; // Or some default value if neither matches
  }
  const [lrType, setLrType] = useState(initialLrType);
  const version = props.version;
  const alternative = props.alternative;
  const publicItem = props.publicItem.currentValue;
  const externalItem= props.externalItem.currentValue;
  const payAmount = props.payAmount;

  function getLabel(key, defaultValue) {
    const returnValue = mappings[key] || defaultValue;
    if (!returnValue) {
      return key;
    }
    return returnValue;
  }

  return (<Box component="section">
    <Grid container spacing={2} justifyContent="flex-start" alignItems="flex-start">
      <Grid item sm={12}>
        <Stack sx={{ pt: 1 }} spacing={1}>
          <div style={{ display: "flex", alignItems: "center", gap: "1em" }}>
            <span>
              <Chip label={getLabel(lrType)} color="secondary" />
            </span>
            {publicItem && (<>
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <Box className="dot" style={{marginRight: "0.5em"}}/><Chip
                  icon={<OpenLockIcon style={{ width: 16, height: 16 }} />}
                  label={messages.public_tag_message || "PUBLIC"}
                  color="success"
                  variant="outlined"
                  size="medium"
                /></Box>
            </>)}
            {externalItem && (<>
              <Box sx={{display: "flex", alignItems: "center", gap: 0.5}}>
                <Box className="dot" /><Chip
                  icon={<OpenLockIcon style={{width: 16, height: 16}} />}
                  label={messages.external_tag_message || "PUBLIC"}
                  color="success"
                  variant="outlined"
                  size="medium"
                /></Box>
            </>)}
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, flexWrap: "wrap" }}>
              {!alternative.isEmpty() && alternative.getList()
                .map((item) => getLabel(item.getValue(defaultLanguage)))
                .filter((label) => label && label.trim() !== "")
                .map((label, index) => (
                  <Box key={index} sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    <Box className="dot" />
                    <Typography variant="body1">{label}</Typography>
                  </Box>
                ))}

              {!isEmpty(version.getValue()) && (
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                  <Box className="dot" />
                  <Typography variant="body1" className="key">
                    {getLabel(keys.version, "version")}: {version.getValue()}
                  </Typography>
                </Box>
              )}
            </Box>
              {payAmount > 0 && <><Box className="dot"></Box> <Typography variant="body1">{messages.all_pages_price_label}: {payAmount} &#8364;</Typography></>}

          </div>
        </Stack>
      </Grid>
    </Grid>
  </Box>
  );
}
